export const lifeFaqList = [
  {
    question: 'How much life insurance coverage do I need?',
    answer:
      "The coverage amount depends on factors like your age, income, liabilities, future financial goals, and your family's needs. A general rule of thumb is to opt for coverage that's at least 10 times your annual income. However, it's best to consult with a financial advisor for a personalized assessment.",
  },
  {
    question: 'What factors should I consider when choosing a life insurance policy?',
    answer:
      "Evaluate factors like premium affordability, coverage duration, payout options (e.g., lump sum or installments), additional benefits or riders (e.g., critical illness coverage), claim settlement ratio, and the insurer's financial stability. Choose a policy that aligns with your needs and financial goals.",
  },
  {
    question: 'How can I assess the reliability of an insurance company?',
    answer: `Research the insurer's claim settlement ratio, which indicates the percentage of claims settled against the total received. Additionally, check the insurer's financial strength ratings from agencies like ICRA, CRISIL, or CARE. This ensures the insurer can honor its commitments over the long term.`,
  },
  {
    question: `What documents are required to purchase life insurance?`,
    answer: `Typically, you'll need identity proof (e.g., Aadhaar card, passport), address proof (e.g., utility bills, rental agreement), income proof (e.g., salary slips, ITR), and recent passport-sized photographs. Additionally, fill out the proposal form accurately, providing all necessary information truthfully.`,
  },
];


export const lifeProductItems = [
  {
    name: 'Term Life Insurance',
    bgColor: 'black',
  },
  {
    name: 'Whole Life Insurance',
    bgColor: 'black',
  },
  {
    name: 'Endowment',
    bgColor: 'black',
  },
  {
    name: 'Unit Linked Plans',
    bgColor: 'black',
  },
  // {
  //   name: 'Fleet Insurance',
  // },
];
